import { css } from 'linaria';

export const setPrice = css`
  margin-top: var(--space-50);
`;

export const buySet = css`
  margin-top: var(--space-200);
`;

export const productCard = css`
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;

  @media (--only-mobile) {
    display: flex;
    flex-direction: column;
    flex: 0 0 50%;
    padding-top: var(--space-250);
    padding-bottom: var(--space-250);
    border-bottom: 1px solid var(--control-minor);

    &:nth-of-type(odd) {
      padding-right: var(--space-250);
      border-right: 1px solid var(--control-minor);
    }

    &:nth-of-type(even) {
      padding-left: var(--space-250);
    }

    &:last-of-type,
    &:nth-last-of-type(2):nth-of-type(odd) {
      border-bottom: none;
    }
  }

  @media (--from-tablet) {
    display: flex;
    height: 200px;
    padding: var(--space-250) 0;
  }
`;

export const productCardImage = css`
  display: block;
  width: 142px;
  height: 142px;

  @media (--only-mobile) {
    object-fit: cover;
    margin-bottom: var(--space-150);
  }

  @media (--from-tablet) {
    margin-right: var(--space-250);
  }
`;

export const productCardContent = css`
  display: flex;
  flex-direction: column;

  @media (--only-mobile) {
    flex-grow: 1;
  }
`;

export const productCardColumn = css`
  display: flex;
  flex-direction: column;

  @media (--only-mobile) {
    margin-top: var(--space-100);
  }
`;

export const productCardInfo = css`
  display: flex;
  margin-top: var(--space-50);

  @media (--only-mobile) {
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
  }
`;

export const productCardName = css`
  margin-top: var(--space-50);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;

  @media (--from-tablet) {
    min-width: 246px;
    width: 246px;
    margin: 0 var(--space-500) var(--space-75) 0;
  }
`;

export const productCardPlenty = css`
  line-height: 16px;

  @media (--from-tablet) {
    margin-top: var(--space-25);
  }
`;

export const productCardPrice = css`
  @media (--only-mobile) {
    line-height: 20px;
  }
`;

export const productCardPlentyPrice = css`
  height: 16px;
  line-height: 16px;
`;

export const productCardPriceWrapper = css`
  display: flex;
  flex-direction: column;
`;

export const priceStub = css`
  visibility: hidden;
  height: 16px;
`;

export const deliveryRow = css`
  display: flex;
  align-items: center;
  padding: var(--space-50) 0;
`;

export const deliveryRowDisable = css`
  opacity: 0.4;
`;

export const deliveryRowWithIcon = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const deliveryIcon = css`
  align-self: baseline;
`;

export const deliveryText = css`
  margin-left: var(--space-150);
`;

export const address = css`
  margin: var(--space-150) 0;
`;

export const delivery = css`
  padding-top: var(--space-150);
`;
